module.exports = __webpack_public_path__ + "img/patrulla_dif_down_selected.478bc5e8.svg";